import { render, staticRenderFns } from "./ListPerguntasParaResponder.vue?vue&type=template&id=5d97d492&"
import script from "./ListPerguntasParaResponder.vue?vue&type=script&lang=js&"
export * from "./ListPerguntasParaResponder.vue?vue&type=script&lang=js&"
import style0 from "./ListPerguntasParaResponder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports